/* eslint-disable react-hooks/exhaustive-deps */
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Grid } from '@mui/material'

import { 
  useGET_setupOptionsQuery,
  usePOST_setupOptionEnableMutation,
  usePOST_setupOptionDisableMutation 
} from 'redux/api/setupApi'

import { Form, Formik } from 'formik'
import CheckboxField from 'components/atoms/fields/CheckboxField'

const SyllabusSetupContactForm: FC = () => {
  const { t } = useTranslation()
  
  const setupOptions = [
    {key: 'syllabus_contact_information', label: t('setup-syllabus-main.contact-information')},
    {key: 'syllabus_course_prerequisites', label: t('setup-syllabus-main.course-prerequisites')},
    {key: 'syllabus_course_materials', label: t('setup-syllabus-main.course-materials-assets')},
    {key: 'syllabus_course_description', label: t('setup-syllabus-main.course-description')},
    {key: 'syllabus_course_instructions', label: t('setup-syllabus-main.course-instructions-activities')},
    {key: 'syllabus_student_participation', label: t('setup-syllabus-main.student-participation')}
  ]

  const { data: setupData } = useGET_setupOptionsQuery()
  const [enableOption, {isLoading: isEnableLoading, isSuccess: isEnableSuccess, error: enableError}] = usePOST_setupOptionEnableMutation()
  const [disableOption, {isLoading: isDisableLoading, isSuccess: isDisableSuccess, error: disableError}] = usePOST_setupOptionDisableMutation()


  const serverValues = {
    options:
      setupData ? setupOptions.map(o => {
        return {
          ...o,
          is_enabled: setupData.filter(s => s.slug == o.key && s.is_enabled).length == 1
        }
      }) : []
  }

  return (

    <>
    {setupData &&
    <Formik
      enableReinitialize
      initialValues={serverValues}
      onSubmit={(values) => {
      }}
    >
      {
        ({ values, setFieldValue, errors }) => 
        <Form>
          <Grid rowSpacing={4} columnSpacing={4} container alignSelf='baseline'>
            {values["options"].map((option,index) => 
              <Grid item xs={12} md={4} key={index}>
                <CheckboxField 
                  isSwitch={true}
                  hasLine={true}
                  index={index}
                  valueSelector='is_enabled'
                  fieldProps={{
                    label: option.label,
                    name: `options[${index}]`
                  }} 
                  onChange={(value)=> {
                    if(value.is_enabled)enableOption(option.key)
                    else disableOption(option.key)
                  }}
                />
              </Grid>
            )}
          </Grid>
        </Form>
      }
    </Formik>
    }
    </>
  )
}
export default SyllabusSetupContactForm

